import React, { memo } from "react";
import { CheckCircle } from "@material-ui/icons";
import styled from "styled-components";

interface IProps {
  disabled?: boolean;
  onClick?: any;
}

const BackgroundCircleButtonStyle = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${(props) => props.theme.backgroundColor};
  margin: 0 8px 0 12px;
`;

const CheckCircleButton = styled.div<IProps>`
  opacity: ${(props) => (props.disabled ? 0.4 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  svg {
    fill: ${(props) => props.theme.primaryColor};
  }
`;

const BackgroundCircleButtonWrapper = (props: IProps) => {
  return (
    <BackgroundCircleButtonStyle>
      <CheckCircleButton
        data-test="button-valid-input"
        onClick={props.onClick}
        disabled={props.disabled}
      >
        <CheckCircle />
      </CheckCircleButton>
    </BackgroundCircleButtonStyle>
  );
};

export const BackgroundCircleButton = memo(BackgroundCircleButtonWrapper);
